import { Record } from 'immutable';
import {
  SET_OFFERING,
  RESET_OFFERING,
} from '../actions/offering-actions';

const OfferingRecord = new Record({
  id: null,
  requestSessionUuid: null,
});

const initialState = new OfferingRecord();

export default (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_OFFERING:
      return state.set('id', action.offering.id)
                  .set('requestSessionUuid', action.requestSessionUuid);
    case RESET_OFFERING:
      return initialState;
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./main/reducers/offering-reducer.js